// ============================================================
// Dashboard Template: Onload initialize and event handling
// ============================================================

// Execute once DOM is ready
$(function(){

  // Custom scrollbars for desktop devices
  if (!isMobileDevice()) {
    $('.menu-drawer .scroller, #cart_window .viewport, #sidenav')
      .mCustomScrollbar({
        scrollInertia: 0, 
        autoHideScrollbar: true, 
        autoExpandScrollbar: true, 
        scrollbarPosition: 'outside', 
        theme: 'dark-thick'
      });
  }

  // Remove sidebar on mobile by default
  window.onresize = setTimeout(function() {
    if (window.innerWidth < 768) {
      $('body').removeClass('menu-open').removeClass('sidebar-open');
      $('[data-appmenu="toggle"], [data-sidebar="toggle"]').removeClass('active');
      $('.navicon-1').removeClass('open');
    }
  }, 0);

  /*
  Danny Mecca 3.4.15 
  When on mobile show this canvas so user can close nav by clicking outside of nav 
  */
  $('.clickCanvasToCloseNav').on('click', function(){
      $('body').removeClass('menu-open').removeClass('sidebar-open');
      $('[data-appmenu="toggle"], [data-sidebar="toggle"]').removeClass('active');
      $('.navicon-1').removeClass('open');
  }); 

  // Menu toggle event
  $(document)
    .on('click', '[data-appmenu="toggle"]', function(e){
      e.preventDefault();
      $('body').toggleClass('menu-open');
      $(this).toggleClass('active').find('[class*="navicon-"]').toggleClass('open');

      // force responsive plugins to re-eval
      $(window).triggerHandler('resize');
    });

  // Sidebar toggle event
  $(document)
    .on('click', '[data-sidebar="toggle"]', function(e){
      e.preventDefault();
      $('body').toggleClass('sidebar-open');

      // force responsive plugins to re-eval
      $(window).triggerHandler('resize');
    });

  // Search toggle event
  $(document)
    .on('click', '[data-appsearch="toggle"]', function(e){
      e.preventDefault();
      $(this).toggleClass('active');
      $('#appSearch').toggleClass('active');
    });


  // Menu state toggle event
  // Save menu state in cookie
  $(document)
    .on('click', '[data-pin="menu"]', function(e){
      e.preventDefault();
      var $this = $(this);
      if ($.cookie('menustate') === 'open') {
        $.cookie('menustate', 'closed');
        $this.removeClass('active').attr('title', 'Lock Menu');
        $('body').removeClass('menu-open');
        $('[data-appmenu="toggle"]')
          .removeClass('active')
          .find('[class*="navicon-"]')
          .removeClass('open');
      } else {
        $.cookie('menustate', 'open');
        $this.addClass('active').attr('title', 'Unlock Menu');
        $('[data-appmenu="toggle"]').addClass('active');
      }
    });

  // Close Sidebar on click
  $('.cart-shelf__close').on('click', function(e) {
    $(document.body).removeClass('sidebar-open');
  })
  

  // Default menu to open on desktop if it has not been locked before,
  // and the screen is large enough
  if(!$.cookie('menustate') && $(window).width() > 1200) {
    $.cookie('menustate', 'open');
    window.location.reload();
  }

  // Auto-close menu when resized below 980px
  // $(window).on('resize load', function(){
  //   if ($(window).width() < 1200) {
  //     $('body').removeClass('menu-open');
  //     $('[data-appmenu="toggle"]').removeClass('active').find('[class*="navicon-"]').removeClass('open');
  //   }
  // });

  /**
   * DDT: Add title attribute for table cells when their content overflows and is hidden
   * (results in tooltip with full content on hover)
   * jonr [2017-07-12]
   */
  $('.DDT-div .tablesaw tbody').on('hover', 'td', function(){
    var $this = $(this);
    var $table = $this.closest('table.tablesaw');
    if(this.offsetWidth < this.scrollWidth && !$this.attr('title')){
      if ($table.hasClass('tablesaw-stack')) {
        $this.attr('title', $this.find('.tablesaw-cell-content').text().trim());
      } else {
        $this.attr('title', $this.text().trim());
      }
    }
  });

  burySkeletons();
  initMenuDrawer();
  updateMenuHeight();
  addWorkspaceToAccountLinks();
  
});
  
function setAccordionHeight(toggle){
  var accAllLinkGroups = document.querySelectorAll('.accordion > .link-parent ul');

  // firefox makes us set an initial inline height
  Array.prototype.slice.call(accAllLinkGroups, 0).forEach(function (group) {
    if(toggle){
      if (!group.style.height) {
        group.style.height = '0px';
      }
    }else{
      group.style.height = '';
    }
  });
}

// ============================================================
// Functions
// ============================================================

function updateMenuHeight() {
  var accLinkParent = document.querySelectorAll('.accordion > .link-parent');

  setAccordionHeight(true);

  Array.prototype.slice.call(accLinkParent, 0).forEach(function (element) {
    if (element.classList.contains('open')) {
      var accLink = element.querySelector('a');
      var accLinkGroup = element.querySelector('ul');
      var accLinkChildren = accLinkGroup.children;
      var accLinkChildrenHeight = 0;
      var accTopLinkGroup = accLink.closest('.accordion > .link-parent').querySelector('ul');

      accLinkGroup.style.height = 0;

      // get immediate children heights
      for (var i = 0; i < accLinkChildren.length; i++) {
        accLinkChildrenHeight += accLinkChildren[i].offsetHeight;
      };

      accLinkGroup.style.height = accLinkChildrenHeight + 'px';
    }
  });
}

/**
 * Skeleton loader for perceived faster loading
 * dnelsen [2020-01-03]
 * jonr [2020-04-29] - moved to function
 */
function burySkeletons() {
  $('.u-skeleton-loader.-window-loaded').removeClass('u-skeleton-loader -circle -full-width -right');
  $('body.-loading-window').removeClass('-loading-window');
  $('.u-skeleton-loader:not(.-window-loaded)').removeClass('u-skeleton-loader -circle -full-width -right');
  $('.u-skeleton-element').remove();
  $('.u-skeleton-group').remove();
  $('body.-loading-dom').removeClass('-loading-dom');
}

/**
 * Expand parent sections for active links in new dashboard menu
 * jonr [2017-07-13]
 */
function initMenuDrawer(){
  var menuDrawer = $('#menuDrawer')
  .find('a[href^="' + location.pathname.substring(location.pathname.lastIndexOf('/') + 1) + '"], a[data-addlink="' + location.pathname.substring(location.pathname.lastIndexOf('/') + 1) + '"]')
    .addClass('active')
  .parents('li.link-parent')
    .addClass('open')
  .parents('.menu-drawer__menu')
    .addClass('active');

  //Fix the selected menu & toolbar when the active link is in "my account"
  if($('.menu-drawer__menu.active').length == 2){
    $($('.menu-drawer__menu.active')[0]).removeClass('active');
  }
  $('#'+$('.menu-drawer__menu.active').attr('id')+'Btn').addClass('active');
  if($('.toolbar__btn.active').length == 2){
    $($('.toolbar__btn.active')[0]).removeClass('active');
  }

  // Flexbox-based accordion navigation
  $('.flex-accordion-trigger').click(function (e) {
    e.preventDefault();
    $(this)
      .closest('.flex-accordion-section')
      .addClass('active')
      .siblings('.flex-accordion-section')
      .removeClass('active')
      .find('.menu-drawer__filter-search')
      .trigger('reset');
  });

}

// ============================================================
// Left App Menu Rail
// ============================================================

// Menu rail vars
var menuDrawer = document.getElementById("menuDrawer");
var menuDrawerBtns = document.getElementsByClassName('toolbar__btn');
var menuDrawerPanels = document.getElementsByClassName('menu-drawer__menu');
var activeMenuDrawerBtn;
var activeMenuDrawerPanel;

// Check our current menustate
if ($.cookie('menustate') === "closed") {
  clearActiveStates(menuDrawerBtns);
  clearActiveStates(menuDrawerPanels);
} else if ($.cookie('menustate') === "open") {

  // Find the current active menu and set its corresponding button to active
  for (var i = 0; i < menuDrawerPanels.length; i++) {
    if (menuDrawerPanels[i].classList.contains("active")) {
      activeMenuDrawerBtn = document.getElementById(menuDrawerPanels[i].id + "Btn");
      if(activeMenuDrawerBtn) activeMenuDrawerBtn.classList.add("active");
    }
  }
}

// Watch our menu rail buttons for clicks
for (var i = 0; i < menuDrawerBtns.length; i++) {
  var menuPanelIdRef = menuDrawerBtns[i].dataset.menu;
  
  // Bind the current menu item as 'this' and menuPanelIdRef to the 
  // updateMenuContent function so the correct vars are passed
  menuDrawerBtns[i].addEventListener("click", updateMenuContent.bind(menuDrawerBtns[i], menuPanelIdRef));
}

$('#toolbarCollapse').on('click',function() {
  if ($('body').hasClass('menu-open')) {
    $.cookie('menustate', 'closed');
    $('body').removeClass('menu-open');
    clearActiveStates(menuDrawerBtns);
  } else {
    $.cookie('menustate', 'open');
    $('body').addClass('menu-open');

    var activeMenu = '';
    $('.menu-drawer__menu').each(function() {
      if ($(this).hasClass('active')) {
        activeMenu = $(this).attr('id');
      }
    });

    if (activeMenu == '') {
      $('#mainMenuBtn').addClass('active');
      $('#mainMenu').addClass('active');
    } else {
      activeMenu = activeMenu + 'Btn';
      $('#'+activeMenu).addClass('active');
    }
  }
});

$('#menuDrawerCollapse').click(function() {
  if ($('body').hasClass('menu-open')) {
    $('body').removeClass('menu-open');
    $.cookie('menustate', 'closed');
    clearActiveStates(menuDrawerBtns);
  } 
});
  
/**
 * Updates the menuDrawer to display its corresponding toolbar 
 * button menu reference, and sets the active states accordingly.
 * 
 * @param menuPanelId
 * 
 * @author dnelsen
 * @since	 02/07/2019
 */
function updateMenuContent(menuPanelId) {
  activeMenuDrawerPanel = $('#'+menuPanelId)[0]; 

  var self = this;

  // If we are clicking on a currently active menu, close it
  if ($(self).hasClass("active")) {

    // Remove the active classes
    $(self).removeClass("active");

    // Close the menuDrawer
    $('body').removeClass('menu-open');
    $.cookie('menustate', 'closed');

  } else {
    // Else if the menu is not yet active

    // Remove all other active states
    clearActiveStates(menuDrawerBtns);
    clearActiveStates(menuDrawerPanels);

    // Add the new active states
    $(self).addClass("active");
    $(activeMenuDrawerPanel).addClass("active");

    // Open the menu
    $('body').addClass("menu-open");
    $.cookie('menustate', 'open');
  }

}

/**
 * Itterates through an array of elements and 
 * removes the active classes.
 * 
 * @param elArray
 * 
 * @author dnelsen
 * @since	 02/07/2019
 */
function clearActiveStates(elArray) {
  for (var i = 0; i < elArray.length; i++) {
    elArray[i].classList.remove("active");
  }
}

// This code will be used in a future update to table styling
/**
 * DDT: Check to see if ddt tables are overflowing, if so add faded edge
 * dnelsen
 
function checkDDTOverflow() {
  $(".ddt-table-wrapper").each(function() {
    if ( $(this)[0].offsetHeight < $(this)[0].scrollHeight || $(this)[0].offsetWidth < $(this)[0].scrollWidth ) {
      $(this).addClass('-overflow');
    } else {
      $(this).removeClass('-overflow');
    }
  });
}

window.addEventListener('resize', _.debounce(checkDDTOverflow, 100));
*/ 


function alertToggle(el) {
  var target = window.event.target;
  var parentAlert = $(target).parents('.alert')
  var toggleEl = parentAlert.children(el);

  $(target).toggleClass('-closed')
  toggleEl.slideToggle();
}


function addWorkspaceToAccountLinks() {
  var accountMenu = document.getElementById('linkset-dashboard-user');

  if (accountMenu) {
    var accountMenuLinks = accountMenu.querySelectorAll('a');
    
    accountMenuLinks.forEach(function(link){
      var href = link.getAttribute('href');
      var hrefAppend;

      if (href.indexOf('?') > 0) {
        hrefAppend = href + '&workspace=accountMenu';
      } else {
        hrefAppend = href + '?workspace=accountMenu';
      }

      link.setAttribute('href', hrefAppend);
    });
  }
}